import { fileURLToPath } from 'node:url';

export function readOptionalTextField(v: unknown): string {
  if (v === null || v === undefined) return '';
  if (typeof v === 'string') return v;
  return '';
}

export function normalizePathField(raw: string): string {
  const t = raw.trim();
  if (t.startsWith('file://')) {
    try {
      return fileURLToPath(t);
    } catch {
      return t;
    }
  }
  return t;
}

export function extractDiffPath(o: Record<string, unknown>): string | null {
  for (const k of ['path', 'file', 'filePath', 'filepath', 'target_path', 'targetPath'] as const) {
    const v = o[k];
    if (typeof v === 'string' && v.trim()) return normalizePathField(v);
  }
  return null;
}
